// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uVxNoDO1S6CObfVfZvpgzA\\=\\={font-size:11px;scroll-margin-left:100px;scroll-margin-right:100px}", "",{"version":3,"sources":["webpack://./src/components/BottomPanel/components/GeneMap/components/GeneMapSVG/style.module.scss"],"names":[],"mappings":"AAAA,4BACE,cAAA,CACA,wBAAA,CACA,yBAAA","sourcesContent":[".geneLabel {\n  font-size: 11px;\n  scroll-margin-left: 100px;\n  scroll-margin-right: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"geneLabel": "uVxNoDO1S6CObfVfZvpgzA=="
};
export default ___CSS_LOADER_EXPORT___;
